/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface PortfolioTag
 */
export interface PortfolioTag {
  /**
   *
   * @type {number}
   * @memberof PortfolioTag
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof PortfolioTag
   */
  name: string
}

/**
 * Check if a given object implements the PortfolioTag interface.
 */
export function instanceOfPortfolioTag(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'name' in value

  return isInstance
}

export function PortfolioTagFromJSON(json: any): PortfolioTag {
  return PortfolioTagFromJSONTyped(json, false)
}

export function PortfolioTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioTag {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    name: json['name'],
  }
}

export function PortfolioTagToJSON(value?: PortfolioTag | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
  }
}
